import { render, staticRenderFns } from "./AtaDirexDetalhar.vue?vue&type=template&id=2740d3e2"
import script from "./AtaDirexDetalhar.vue?vue&type=script&lang=js"
export * from "./AtaDirexDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports